import React, { useMemo } from "react";
import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import {
  AuthContextData,
  AuthProviderProps,
  ClaimsContextData,
} from "../interfaces";

const AuthContext = React.createContext({} as AuthContextData);

export function AuthProvider({ children }: AuthProviderProps) {
  const { accounts, inProgress, instance } = useMsal();
  const [claim, setClaim] = useState({} as ClaimsContextData);
  const [token, setToken] = useState<string | null>(null);

  const logout = () => {
    instance.logoutRedirect();
    window.localStorage.clear();
    console.log("logout");
    
    // window.location.reload();
  }

  useEffect(() => {
    if (inProgress === "none" && accounts.length > 0) {
      const request = {
        account: accounts[0],
        scopes: ["openid"],
      };
      // Retrieve an access token
      instance
        .acquireTokenSilent(request)
        .then((response) => {
          if (response.idToken) {
            console.log(response.idTokenClaims);
            
            const { name, extension_email }: any = response.idTokenClaims;
            setToken(response.idToken);

            setClaim({
              name,
              email: !!extension_email ? extension_email : ""
            });

            return response.accessToken;
          }
          return null;
        })
        .catch((error) => {
          console.log("token error", error);
          instance.logoutRedirect();
        });
    }
  }, [inProgress, accounts, instance]);
 
  const AuthContextValue = useMemo(
    () => ({ token, claim, logout }),
    [token, claim, logout]
  );
  console.log(AuthContextValue);
  

  return token ? (
    <AuthContext.Provider value={AuthContextValue}>
      {children}
    </AuthContext.Provider>
  ) : null;
}

export default AuthContext;
